import { STATIC_URLS } from "./util.constants"

export const convertPointToPrice = points => {
  return points / 100
}

// Assume Playerbase credit is in USD and is represented as cents
export const convertPbCreditToUsd = amount => {
  return amount / 100
}

export const formatPrice = (amount, currency, minimumFractionDigits) => {
  minimumFractionDigits = minimumFractionDigits || 2
  const options = {
    style: "currency",
    currency: currency,
    minimumFractionDigits: minimumFractionDigits,
  }
  return Intl.NumberFormat("en", options).format(amount)
}

export const formatPriceUSD = price => {
  return formatPrice(price, "USD")
}

export const formatPriceToNumber = price => {
  return Number(price.toString().replace(/[^0-9.-]+/g, ""))
}

export const isPageStatic = panth => STATIC_URLS.includes(panth)

export const checkBrowser = () => {
  if ((navigator.userAgent.indexOf("Opera") !== -1 || navigator.userAgent.indexOf('OPR')) !== -1) {
    return "opera"
  } else if (navigator.userAgent.indexOf("Chrome") !== -1) {
    return "chrome"
  } else if (navigator.userAgent.indexOf("Safari") !== -1) {
    return "safari"
  } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
    return "firefox"
  } else if ((navigator.userAgent.indexOf("MSIE") !== -1) || (!!document.documentMode === true)) {
    return "internet-explorer"
  } else {
    return "unknown"
  }
}



// WEBPACK FOOTER //
// ./src/store/utils/util.utils.js